import { render, staticRenderFns } from "./MassPendingInfo.vue?vue&type=template&id=7bcbb224&"
import script from "./MassPendingInfo.vue?vue&type=script&lang=js&"
export * from "./MassPendingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports